import { get } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";
import { OppoUtils } from "../../utils";

const { APIS } = API_ENDPOINTS;

export const fetchAllOpportunities = filters => {
  console.debug(filters);
  const url = filters
    ? OppoUtils.prepareFilteredOpportunitiesUrl(filters, APIS.OPPORTUNITIES)
    : APIS.OPPORTUNITIES;
  // let url = APIS.OPPORTUNITIES;
  console.debug(url);
  return new Promise((resolve, reject) => {
    get(`${url}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const fetchOpportunities = async filters => {
  const url = filters
    ? OppoUtils.prepareFilteredOpportunitiesUrl(filters, APIS.OPPORTUNITIES)
    : APIS.OPPORTUNITIES;

  const Opportunities = await get(`${url}`)
    .then(res => res)
    .catch(error => console.error(error));
  return Opportunities;
};

export const fetchAllAccountsByUser = () =>
  new Promise((resolve, reject) => {
    get(APIS.ACCOUNTS)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchAllOpportunitiesByAccount = accountID =>
  new Promise((resolve, reject) => {
    get(`${APIS.OPPORTUNITIES}?account=${accountID}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchAllOpportunityStages = () =>
  new Promise((resolve, reject) => {
    get(APIS.OPPORTUNITY_STAGES)
      .then(res => {
        console.debug(res);
        resolve(res.Stages);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getAllPricebooksService = () =>
  new Promise((resolve, reject) => {
    get(APIS.PRICE_LISTS)
      .then(res => {
        resolve(res.PriceListPage.plists);
      })
      .catch(err => {
        reject(err);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/OpportunitiesActions/opportunitiesService.js